export default (entities) => ({
  confirmSalesOrder(address, cart, transaction) {
    return entities.SalesOrder.confirm(address, cart, transaction);
  },
});
